import * as React from 'react';
import RadioButtonField from 'myshubhlife-component/radioButtonField';
import {IRadioButtonProps} from 'myshubhlife-component/form/FormInterfaceProps';


function RadioButton (props: IRadioButtonProps) {
  const handleChange = (index: number, fieldName: string | number, value: string | number) => {
    props.handleFormChange(value, props.index, 'value');
  }
  return (
    <div className="s-form-group-field">
      <RadioButtonField 
      buttonList={props.field.options}
      value={props.field.value}
      label={props.field.label}
      fieldName={props.field.identifier}
      errorMsg={props.field.errorMsg}
      onChangeHandler={handleChange}
      index={props.index}
      disabled={props.field.disabled}
      activeColor={props.field.activeColor}
      iconUrl={props.field.iconUrl}
      isRequired={props.field.isRequired}
      tooltipLabel={props.field.tooltipLabel}
       />
    </div>
  )
}

export default RadioButton;